class MainBlog extends HTMLElement {
  constructor() {
    super();
    this.loadMore = this.querySelector("[data-load-more]");

    if (!this.loadMore) return;

    this.grid = this.querySelector("[data-grid]");

    this.loadMore.addEventListener("click", (e) => {
      e.preventDefault();

      fetch(this.loadMore.href)
        .then((response) => response.text())
        .then((response) => {
          const doc = new DOMParser().parseFromString(response, "text/html");

          const newLoadMore = doc.querySelector("[data-load-more]");
          if (!newLoadMore) {
            this.loadMore.style.display = "none";
          } else {
            this.loadMore.href = newLoadMore.href;
          }

          this.grid.append(...doc.querySelectorAll("[data-card]"));
        });
    });
  }
}

if (!customElements.get("main-blog")) {
  customElements.define("main-blog", MainBlog);
}
